/*
  엑셀 파일 드래그앤드롭 / 파일 선택 박스

  파일을 고르기 전에는 안내 문구 + [파일 선택], 고른 뒤에는 파일명 + [초기화] 를 보여준다.
  파싱·업로드는 사용하는 화면이 담당한다(이 컴포넌트는 File 객체만 전달).
*/
import React, { useRef, useState } from 'react';
import styled from 'styled-components';

const Box = styled.div`
  display: flex;
  height: 240px;
  margin-bottom: 4px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px dashed #c8c8c8;
  border-radius: 4px;
  background: #f5f5f5;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &.active {
    border-color: #3ea856;
    background: #f0faf3;
  }

  .excel-dropzone-input {
    display: none;
  }

  .excel-dropzone-text {
    margin: 0;
    color: #8e8e8e;
    font-size: 14px;
    line-height: 1.5;
  }

  .excel-dropzone-text + .excel-dropzone-text {
    margin-top: 2px;
  }

  .excel-dropzone-file-name {
    margin: 0;
    color: #353c49;
    font-size: 14px;
    line-height: 1.5;
  }

  .excel-dropzone-button {
    margin-top: 8px;
    padding: 6px 16px;
    border: 1px solid #3ea856;
    border-radius: 4px;
    background: #ffffff;
    color: #3ea856;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
      background: #f0faf3;
    }
  }

  .excel-dropzone-reset-button {
    margin-top: 8px;
    padding: 6px 16px;
    border: 1px solid #db2828;
    border-radius: 4px;
    background: #ffffff;
    color: #db2828;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
      background: #fff5f5;
    }
  }
`;

const ExcelDropzone = ({ file, onFileSelect, onReset, accept = '.xlsx,.xls' }) => {
  const inputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => setIsDragOver(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);

    const dropped = e.dataTransfer.files[0];
    if (dropped) onFileSelect(dropped);
  };

  const handleChange = (e) => {
    const selected = e.target.files[0];
    if (selected) onFileSelect(selected);
    // 같은 파일을 다시 골라도 change 가 발생하도록 값을 비운다
    e.target.value = '';
  };

  const openFileDialog = () => inputRef.current.click();

  return (
    <Box
      className={isDragOver ? 'active' : null}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <input ref={inputRef} type="file" accept={accept} className="excel-dropzone-input" onChange={handleChange} />

      {file ? (
        <React.Fragment>
          <p className="excel-dropzone-file-name">{file.name}</p>
          {onReset ? (
            <button type="button" className="excel-dropzone-reset-button" onClick={onReset}>
              초기화
            </button>
          ) : null}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <p className="excel-dropzone-text">파일을 이곳에 끌어다 놓으세요.</p>
          <p className="excel-dropzone-text">또는 파일 선택 버튼을 눌러 업로드 해주세요.</p>
          <button type="button" className="excel-dropzone-button" onClick={openFileDialog}>
            파일 선택
          </button>
        </React.Fragment>
      )}
    </Box>
  );
};

export default ExcelDropzone;
